import SideBarContainer from 'Containers/SideBarContainer';
import ReportsLayout from 'Pages/reports/components/ReportsLayout/ReportsLayout';
import useCoursesReportPage from './hooks/useCoursesReportPage';
import ReportsTitle from 'Pages/reports/components/ReportsTitle/ReportsTitle';
import { Padding } from 'Components/Padding';
import CoursesReportsFilters from './components/CoursesReportFilters/CoursesReportFilters';
import ReportsDataGrid from 'Pages/reports/components/ReportsDataGrid/ReportsDataGrid';
import ProgressIndicator from 'Components/ProgressIndicator';
import { useHistory } from 'react-router-dom';
import GenericTableText from 'Components/GenericTableText/GenericTableText';
import useReportButtons from 'Pages/reports/hooks/useReportButtons';
import { ReportsButtonGroup } from 'Pages/reports/components/ReportsButtonGroup/ReportsButtonGroup';
import { buildTime } from 'Pages/reports/utils/buildTime';
import type { GridColDef } from '@mui/x-data-grid';

interface Row {
  id: string;
  name: string;
  priority: string;
  totalUsers: number;
  totalUsersCompleted: number;
  category: string;
  trainingHours: number | null;
}

export default function Page() {
  const history = useHistory();
  const {
    t2,
    onSearch,
    coursesReportData,
    pagination,
    loading,
    error,
    handlePageChange,
    handleRowsPerPageChange,
    onExport,
  } = useCoursesReportPage();

  const buttons = useReportButtons();

  const columns: GridColDef[] = [
    { field: 'name', headerName: t2('name'), flex: 1.5 },
    { field: 'priority', headerName: t2('priority'), flex: 1 },
    {
      field: 'totalUsers',
      headerName: t2('total_employees'),
      flex: 1,
      align: 'center',
      headerAlign: 'center',
    },
    { field: 'category', headerName: t2('category'), flex: 1 },
    {
      field: 'progress',
      headerName: t2('progress'),
      flex: 1.2,
      align: 'center',
      headerAlign: 'center',
      renderCell: params => (
        <ProgressIndicator
          completed={params.row.totalUsersCompleted}
          total={params.row.totalUsers}
          emptyMessage={t2('no_progress')}
        />
      ),
    },
    {
      field: 'trainingHours',
      headerName: t2('training_hours'),
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      renderCell: params =>
        params.row.trainingHours ? (
          buildTime(params.row.trainingHours, t2)
        ) : (
          <GenericTableText text={t2('no_training_hours')} />
        ),
    },
  ];

  const rows: Row[] = coursesReportData.map(course => ({
    id: course.id,
    name: course.name,
    priority: course.priority,
    totalUsers: course.totalUsers,
    totalUsersCompleted: course.totalUsersCompleted,
    category: course.category,
    trainingHours: course.trainingHours,
  }));

  return (
    <SideBarContainer>
      <ReportsLayout
        title={<ReportsTitle title={t2('title')} accent={t2('title_accent')} />}
        buttons={<ReportsButtonGroup buttons={buttons} />}
        onExport={onExport}
      />
      <Padding padding="1rem">
        <CoursesReportsFilters onSearch={onSearch} />
        <Padding padding="1rem 0" />
        <ReportsDataGrid<Row>
          columns={columns}
          rows={rows}
          loading={loading}
          error={error}
          pagination={pagination}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          onRowClick={row => history.push(`/reporte/cursos/${row.id}`)}
        />
      </Padding>
    </SideBarContainer>
  );
}
